var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInsights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "gg5jmuwfja",
    d: "M11 4.005v2.016c-3.392.486-6 3.403-6 6.93 0 3.866 3.134 7 7 7 3.526 0 6.443-2.608 6.929-6h2.016c-.498 4.5-4.313 8-8.945 8-4.97 0-9-4.03-9-9 0-4.633 3.5-8.448 8-8.946zM13 3c4.725.47 8.482 4.226 8.95 8.95H16.9c-.398-1.958-1.94-3.501-3.9-3.9V3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.000000, -300.000000) translate(0.000000, 288.000000) translate(24.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rbazwop1ub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gg5jmuwfja"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0.87,
    mask: "url(#rbazwop1ub)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInsights);
export default __webpack_public_path__ + "static/media/icon-insights.959fc5ad3a06bc3b37686937c6d42c8c.svg";
export { ForwardRef as ReactComponent };